import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-23",
  "use": "icon-button_icon-23-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-23\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\"1.75\" y=\"1.75\" width=\"8.5\" height=\"8.5\" rx=\"2\" /><rect x=\"13.75\" y=\"1.75\" width=\"8.5\" height=\"8.5\" rx=\"2\" /><rect x=\"1.75\" y=\"13.75\" width=\"8.5\" height=\"8.5\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M18 14.944v7.112M14.444 18.5h7.112\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol